import {
  Breakpoint,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';

interface Props {
  title: string;
  isOpen?: boolean;
  maxWidth?: Breakpoint;
  onClose: () => void;
  isTestMode: any;
  handleTestMode: any;
}

function Confirm(props: Props) {
  const {
    title,
    isOpen = false,
    maxWidth = 'sm',
    onClose,
    isTestMode,
    handleTestMode,
  } = props;

  const handleStart = () => {
    handleTestMode();
    onClose();
  };

  return (
    <Dialog maxWidth={maxWidth} open={isOpen} onClose={onClose}>
      <DialogTitle>
        <DialogActions sx={{ padding: '10px 0 0 0 ' }}>
          <Typography
            sx={{
              marginRight: 'auto',
              fontWeight: '600',
              fontSize: 16,
            }}
          >
            {title}
          </Typography>
        </DialogActions>
      </DialogTitle>
      <DialogContent
        sx={{
          whiteSpace: 'pre-line',
          wordBreak: 'keep-all',
          lineHeight: '24px',
        }}
      >
        <span>Туршилтын горимд дараах хязгаарлалт үйлчилнэ.</span>
        <DialogContent
          sx={{
            whiteSpace: 'pre-line',
            wordBreak: 'keep-all',
            lineHeight: '24px',
            fontSize: '14px',
          }}
        >
          <li>Бусад өвчтөний бичлэг рүү шилжих боломжгүй.</li>
          <li>Хулганы баруун товчны үйлдэл идэвхгүй.</li>
          <li>Текст блок сонголт хийх боломжгүй.</li>
          <li>
            Туршилтын горимоос гарах бол системээс гарч дахин нэвтэрнэ үү.
          </li>
        </DialogContent>
        <DialogActions>
          <Button
            variant="text"
            onClick={onClose}
            sx={{ marginTop: '-20px', color: '#E63529', fontSize: '14px' }}
          >
            Цуцлах
          </Button>
          <Button
            type="submit"
            variant="text"
            onClick={handleStart}
            sx={{
              marginTop: '-20px',
              color: '#1976D2',
              fontSize: '14px',
            }}
          >
            Туршилтын горим эхлүүлэх
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
}

export default Confirm;
